import WaterIcon from './component'

export default WaterIcon
